import WithRoleAuthorization, { listOfRoles } from 'components/WithRoleAuthorization/WithRoleAuthorization'
import React from 'react'
import { ArchiveButton } from '../../styles'
import { UserDataType } from 'types/autentication'
import { featureFlags } from 'config/featureFlags'

export interface IRemoveGroupNotifications {
  currentUser: UserDataType
  handleRemoveNotifications: () => void
  isDirtyStyle: "" | "border-mediumGray text-mediumGray"
  isDirty: boolean
  hasSelectedNotifications: boolean
  selectedCount: number
}

export const removeAllowedUsers = [listOfRoles.admin, listOfRoles.location_qa, listOfRoles.location_manager]

export default function RemoveGroupNotifications({ 
  isDirty, 
  isDirtyStyle, 
  currentUser, 
  handleRemoveNotifications,
  hasSelectedNotifications,
  selectedCount
}: IRemoveGroupNotifications) {
  
  if (!featureFlags.groupNotifications || !hasSelectedNotifications) {
    return null
  }

  const getButtonText = () => {
    if (selectedCount === 1) {
      return (
        <>
          Remover <span className="m-0 font-bold">1 notificação</span> do tratamento em grupo
        </>
      )
    }
    return (
      <>
        Remover <span className="m-0 font-bold">{selectedCount} notificações</span> do tratamento em grupo
      </>
    )
  }

  return (
    <WithRoleAuthorization
      allowedRoles={removeAllowedUsers}
      userRole={currentUser?.profile}
      children={
        <ArchiveButton
          data-testid="test-remove-group-notifications-button"
          className={isDirtyStyle}
          disabled={!!isDirty}
          type="button"
          onClick={handleRemoveNotifications}
        >
          {getButtonText()}
        </ArchiveButton>
      }
    />
  )
}